import { useMutation } from '@tanstack/react-query';
import { patchProcessedTimesheetHeader } from '../Services/ProcessedTimesheetService';

const usePatchProcessedTimesheet = (options = {}) =>
    useMutation(patchProcessedTimesheetHeader, options);

export default usePatchProcessedTimesheet;
